import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makeDeleteRequest } from 'owa-ows-gateway';

import getEntryPoint from '../selectors/getEntryPoint';
import { getUserMailboxGuid } from '../utils/getMailboxGuid';
import getMailboxPuid from '../selectors/getMailboxPuid';
import getPageOrigin from '../selectors/getPageOrigin';

export default async function deleteMeetingTypeExtension(itemId: string): Promise<boolean> {
    const url = `ows/beta/BookWithMe/DeleteMeetingTypeExtension?itemid=${itemId}`;
    const perfDatapoint = new PerformanceDatapoint('deleteMeetingTypeExtension');
    perfDatapoint.addCustomData({
        meetingTypeId: itemId,
        entryPoint: getEntryPoint(),
        mailboxGuid: getUserMailboxGuid(),
        bookingMailboxPuid: getMailboxPuid(),
        pageOrigin: getPageOrigin(),
    });
    /* eslint-disable-next-line owa-custom-rules/require-mailboxInfoInOwsRequest  -- (https://aka.ms/OWALintWiki)
     * MailboxInfo must be providded to OWS calls, see https://aka.ms/multiaccountlinter
     *	> All OWS calls must pass in a MailboxInfo or OwsRequestOptions obtained via getOwsMailboxRequestOptions. */
    const response = await makeDeleteRequest(
        url,
        undefined,
        undefined,
        true,
        undefined /* customHeaders */,
        undefined /* throwServiceError */,
        undefined /* includeCredentials */,
        'deleteMeetingTypeExtension'
    );

    if (isSuccessStatusCode(response.status)) {
        perfDatapoint.end();
        return true;
    } else {
        perfDatapoint.endWithError(DatapointStatus.ServerError);
        return false;
    }
}
